import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { formatCurrency } from 'Helpers/UiHelper';

const InitiatorChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-center text-muted">No data available</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="who" tick={{ fontSize: 12 }} />
        <YAxis yAxisId="count" orientation="left" allowDecimals={false} />
        <YAxis yAxisId="cost" orientation="right" tickFormatter={(value) => formatCurrency(value)} />
        <Tooltip
          formatter={(value, name) => {
            if (name === 'Cost') return [formatCurrency(value), name];
            return [value, name];
          }}
        />
        <Legend />
        <Bar yAxisId="count" dataKey="count" name="Count" fill="#36b9cc" />
        <Bar yAxisId="cost" dataKey="cost" name="Cost" fill="#f6c23e" />
      </BarChart>
    </ResponsiveContainer>
  );
};

InitiatorChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      who: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      cost: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default InitiatorChart;
